// stores/lang.js
import { defineStore } from "pinia";
import i18n from "../i18n";

export const uselangStore = defineStore("lang", {
  state: () => ({
    lang: localStorage.getItem("lang") || "en",
  }),
  actions: {
    changeLang(lang: any) {
      console.log("切换语言", lang);
      // if (["en", "zh"].indexOf(lang) === -1) lang = "zh";
      this.lang = lang;
      localStorage.setItem("lang", lang);
      i18n.global.locale.value = lang;
    },
  },
});
